import { getLogger } from "@expert/logging";
import type { ContentfulClientApi, EntryFieldTypes, EntrySkeletonType } from "contentful";

const logger = getLogger({
    module: "getCallIntroFlowQuestions",
    supportTeam: "sales",
});

export interface CallIntroFlowQuestions {
    question: string;
    options: string[];
}

interface CallIntroFlowContent {
    partner: EntryFieldTypes.Symbol;
    question: EntryFieldTypes.Symbol;
    options: EntryFieldTypes.Array<EntryFieldTypes.Symbol>;
}

export async function getCallIntroFlowQuestions(
    client: ContentfulClientApi<undefined>,
    partner: string,
): Promise<CallIntroFlowQuestions | null> {
    try {
        const response = await client.withoutUnresolvableLinks.getEntries<EntrySkeletonType<CallIntroFlowContent>>({
            content_type: "callIntroFlowQuestions",
            "fields.partner": partner,
        });

        if (response.items.length === 0) return null;

        return { question: response.items[0]?.fields.question, options: response.items[0]?.fields.options };
    } catch (error) {
        logger.error({ error, partner }, "Error fetching call intro flow questions");
        throw error;
    }
}
